import { useState, useEffect } from "react";
import BaseHeading from "../baseComponents/baseHeading";
import BaseParagraph from "../baseComponents/baseParagraph";
import { getters as dictionaryGetters } from "../store/slices/dictionarySlice";
import { useSelector } from "react-redux";
import AddModal from "../utilComponents/AddModal";

const WithContactInfo = (Component) => {
  const NewComponent = (...props) => {


    const staticContactAdress = process.env.REACT_APP_CONTACT_STATIC_ADRESS;
    const staticContactEmail = process.env.REACT_APP_CONTACT_STATIC_EMAIL;
    const staticContactPhone = process.env.REACT_APP_CONTACT_STATIC_PHONE;
    const staticContactPhoneIsFree =
      process.env.REACT_APP_CONTACT_STATIC_PHONE_IS_FREE;

    const isDictionaryLoaded = useSelector(
      dictionaryGetters.isDictionaryLoaded
    );

    const modalLabel = isDictionaryLoaded ? "contact" : "Kontakt";
    const adressLabel = isDictionaryLoaded ? "address" : "Adresa";
    const mailLabel = isDictionaryLoaded ? "email" : "E-mail";
    const phoneLabel = isDictionaryLoaded ? "phone" : "Telefon";
 



    const ComponentForModal = ({ openModal,  }) => {
      return <Component {...props} openContactInfo={openModal} />;
    };

    const DetailInfo = ({ closeModal,isModalFullyOpened, isModalOpened }) => {

      return (
        <>
          {staticContactAdress && (
            <div>
              <BaseParagraph translate={isDictionaryLoaded}>
                {adressLabel}
              </BaseParagraph>
              <span>:</span>
              <span>&nbsp;</span>
              <BaseParagraph translate={false}>
                {staticContactAdress}
              </BaseParagraph>
              <br />
              <br />
            </div>
          )}
          {staticContactEmail && (
            <div>
              <BaseParagraph translate={isDictionaryLoaded}>
                {mailLabel}
              </BaseParagraph>
              <span>:</span>
              <span>&nbsp;</span>
              <BaseParagraph translate={false}>
                {staticContactEmail}
              </BaseParagraph>
              <br />
              <br />
            </div>
          )}

          {staticContactPhone && (
            <div>
              <BaseParagraph translate={isDictionaryLoaded}>
                {phoneLabel}
              </BaseParagraph>
              <span>:</span>
              <span>&nbsp;</span>
              <BaseParagraph translate={false}>
                {staticContactPhone}
              </BaseParagraph>
              {staticContactPhoneIsFree === true && (
                <>
                  <span>&nbsp;</span> <span>&nbsp;</span> <span>(</span>
                  <BaseParagraph>tollFree</BaseParagraph>
                  <span>)</span>
                </>
              )}
              <br />
            </div>
          )}
        </>
      );
    };

    return (
      <>
        <AddModal
          Component={ComponentForModal}
          ModalContent={DetailInfo}
          ModalHeader={() => (
            <BaseHeading translate={isDictionaryLoaded}>
              {modalLabel}
            </BaseHeading>
          )}
        />
      </>
    );
  };

  return NewComponent;
};

export default WithContactInfo;
